<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-md-12">
                <button type="button" @click="back()" class="btn btn-default mb-10">
                    <i class="fa fa-angle-left"></i>
                    Voltar
                </button>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <form @submit.prevent="search">
                    <div class="card">
                        <div class="card-header">
                            <i class="fa fa-search"></i> Pesquisar
                        </div>
                        <div class="card-block">
                            <div class="form-group row">
                                <div class="col-md-4 col-xs-12">
                                    <label>Cliente</label>
                                    <input
                                        type="text"
                                        maxlength="150"
                                        class="form-control"
                                        v-model="filter.cliente"
                                    />
                                </div>

                                <div class="col-md-4 col-xs-12">
                                    <label>Nº do Contrato</label>

                                    <input
                                        type="text"
                                        maxlength="100"
                                        class="form-control"
                                        v-model="filter.numeroContrato"
                                    />
                                </div>
                                <div class="col-md-4 col-xs-12">
                                    <label>Pet</label>

                                    <input
                                        type="text"
                                        maxlength="100"
                                        class="form-control"
                                        v-model="filter.nome"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <div class="row">
                                <div class="col-md-12 text-right">
                                    <button
                                        type="button"
                                        @click="clean"
                                        class="btn btn-primary"
                                    >Limpar</button>
                                    <button type="submit" class="btn btn-default">
                                        <i class="fa fa-search"></i> Pesquisar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <dw-table-header :size="size" @finish="updateSize" :pagination="list"></dw-table-header>
                    </div>
                    <div class="card-block">
                        <table class="table table-bordered table-striped table-md">
                            <dw-table-head :headers="headers" :editable="true" @update="sort"></dw-table-head>

                            <tbody>
                                <tr v-for="item in list.rows">
                                    <td :data-label="headers[0].name">{{ item.id }}</td>
                                    <td :data-label="headers[1].name">{{ item.usuario.nome }}</td>
                                    <td :data-label="headers[2].name">{{ item.pets[0].nome}}</td>
                                    <td :data-label="headers[3].name">{{ item.contrato}}</td>

                                    <td
                                        :data-label="headers[4].name"
                                    >{{ item.dataInicio | formatDate('DD/MM/YYYY HH:mm') }}</td>
                                    <!-- <td :data-label="headers[3].name">{{ item.contrato}}</td> -->

                                    <td>
                                        <button
                                            class="btn btn-info btn-sm"
                                            @click="edit(item.id, item.usuario.id)"
                                            v-tooltip="'Visualizar'"
                                        >
                                            <i class="far fa-eye"></i>
                                        </button>
                                        <a
                                            class="btn btn-primary btn-sm"
                                            :href="item.arquivo.url"
                                            target="_blank"
                                            v-tooltip="'Baixar'"
                                        >
                                            <i class="fas fa-file-download"></i>
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <dw-pagination
                            :pagination="list"
                            :page="page"
                            @update="fetchData"
                            :offset="size"
                        ></dw-pagination>
                    </div>
                </div>
            </div>
            <!--/.col-->
        </div>
        <!--/.row-->
    </div>
</template>

<script>
import {
    isUndefinedOrNullOrEmpty,
    clearCpfCnpj,
    clearPhone
} from "@/services/string";
import Collections from "@/helpers/collections";
import Facade from "../../../facade/facade";
import Select2 from "../../../components/Input/Select2";
const facade = new Facade();

export default {
    components: { Select2 },
    data() {
        return {
            headers: [
                { name: "Cód.", key: "id" },
                { name: "Cliente", key: "`usuario.nome`", sort: false },
                { name: "Pet", key: "`pets.nome`", sort: false },
                { name: "Contrato", key: "nome" },
                { name: "Inicio", key: "dataInicio" }
            ],
            filter: {
                numeroContrato: "",
                nome: "",
                cliente: ''
            },
            model: {
                usuario: {}
            },
            list: {},
            size: 20,
            page: 0
        };
    },
    computed: {
        isAdmin() {
            return facade.isAdmin();
        }
    },
    methods: {
        sort(data) {
            this.order = [data.key, data.direction];
            this.fetchData(this.page);
        },
        back() {
            this.$router.push({
                name: "list-client",
                params: {
                    idCliente: this.$route.params.idCliente
                }
            });
        },
        clean() {
            this.filter = {
                numeroContrato: null,
                nome: null,
                cliente: ''
            };
        },

        edit(id, idUsuario) {
            this.$router.push({
                name: "edit-policies",
                params: {
                    idPolicy: id,
                    id: idUsuario
                }
            });
        },

        async fetchData(page) {
            try {
                let vm = this;
                vm.page = page;
                let idClient = vm.$route.params.id;

                let params = {
                    params: {
                        page: vm.page,
                        size: vm.size,
                        order: vm.order,
                        idClient: idClient,
                        nome: vm.filter.nome,
                        numeroContrato: vm.filter.numeroContrato
                    }
                };
                for (let key in this.filter) {
                    if (this.filter.hasOwnProperty(key)) {
                        params["params"][key] = this.filter[key];
                    }
                }
                if (idClient) {
                    let ret = await facade.listPoliciesClient(params);
                    vm.list = ret.data.data;
                    this.$loading.show(false);
                } else {
                    let ret = await facade.listPolicies(params);
                    vm.list = ret.data.data;
                    this.$loading.show(false);
                }
            } catch (e) {
                this.$notify.error(
                    "Erro!",
                    "Ocorreu um problema ao listar as apólices."
                );
                this.$loading.show(false);
            }
        },
        search() {
            this.fetchData(0);
        },
        updateSize(value) {
            let vm = this;
            vm.size = value;
            this.fetchData(0);
        }
    },
    beforeMount() {
        this.fetchData(0);
    }
};
</script>



// WEBPACK FOOTER //
// List.vue?2a2c727d